import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NoAccessComponent } from './no-access/no-access.component';
import {AuthGuard} from './Shared/auth.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import {FormComponent} from './form/form.component';


const routes: Routes = [
  {
    path: '',
    loadChildren: './login/login.module#LoginModule'
  },
  {
    path: 'profile',
    loadChildren: './layout/layout.module#LayoutModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'noaccess',
    component: NoAccessComponent
  },
  {
    path: 'form/:id',
    component: FormComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
